import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from "moment";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { LmsService } from "../../_Lms/services/lms.service";
import { MasterService } from "../../Shared/app.Masters.Service";
import { ReportsService } from "../services/reports.service";
import { LosService } from "src/app/_LOS/services/los.service";
@Component({
    selector: "app-user-defined-report",
    templateUrl: "./user-defined-report.component.html",
    styleUrls: ["./user-defined-report.component.scss"],
    standalone: false
})
export class UserDefinedReportComponent implements OnInit, AfterViewInit {
  currentUser: any;
  showSpinner = false;
  reportData: any[] = [];
  clientData: any[] = [];
  selectedReport: any = null;
  ToDate: any = new Date();
  FromDate: any = new Date();
  data: any = "";
  originalData: any[] = [];

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>([]);
  BranchesList: any = [];
  BranchId: any = "";
  branchFilter = '';
searchFilter = '';
  SelectSourceType: any = '';
  LeadSourceName: any[] = [];
  partnerDropdown: any[] = [];
  leadSourceDropdown: any[] = [];
  LoanAccountCategory: any[] = [];
  catgegoryIdList: any = [];
  SalesExecutiveData: any = [];
  sourceNameDropdownSettings = {
    singleSelection: false,
    idField: "PartnerId",
    textField: "Partner_Name",
    selectAllText: "Select All",
    unSelectAllText: "Deselect All",
    itemsShowLimit: 1,
    allowSearchFilter: true,
    closeDropDownOnSelection: false,
    showSelectedAllText: true,
    maxHeight: 190,
    searchPlaceholderText: "Search Source Name",
    showSelectedItemsAtTop: true,
  };
  categoryDropdownSettings: any = {};
  ProductId: any = '';
  ProductList: any = [];
  BranchIds: any[] = [];
  SblProductIds: any[] = [];
  branchDropdownSettings: any = {};
  productDropdownSettings: any = {};
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private MasterService: MasterService,
    private lmsService: LmsService,
    private snackBar: MatSnackBar,
    private losService: LosService,
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("User-Defined Report");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.Get_User_Defined_Reports();
    this.getBranchesList();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  isDateInRange(row: any): boolean {
    if (!row.PaymentDate || row.PaymentDate === "Total") return false;
    // Try to parse PaymentDate as DD-MM-YYYY or DD/MM/YYYY
    const paymentDate = moment(
      row.PaymentDate,
      ["DD-MM-YYYY", "DD/MM/YYYY"],
      true,
    );
    if (!paymentDate.isValid()) return false;
    const from = moment(this.FromDate);
    const to = moment(this.ToDate);
    return (
      paymentDate.isSameOrAfter(from, "day") &&
      paymentDate.isSameOrBefore(to, "day")
    );
  }
  isTotalRow(row: any): boolean {
    return row.PaymentDate === "Total";
  }

  isNegativeXirr(row: any): boolean {
    return row.Closed_Xirr < 0;
  }
  changeHeaderTitle() {
    this.dataSharingService.HeaderTitle.next(
      this.selectedReport.Report_Name || "User-Defined Report",
    );
     if (this.selectedReport?.From_Date) {
      this.FromDate = new Date();
    } else {
      this.FromDate = new Date(2000, 0, 1);
    }
    if (
      this.selectedReport?.Report_Name === 'Disbursement Summary' ||
      this.selectedReport?.Report_Name === 'Los Booking list'
    ) {
      this.loadShortBookingListDropdowns();
    }
  }

  loadShortBookingListDropdowns() {
    this.getLeadSourceDropdown();
    this.GetSalesExecutive();
    this.Get_Loan_Accounting_Category_ForDropdown();
    this.initializeCategoryDropdownSettings();
    this.getProductDropdown();
    this.initializeBranchDropdownSettings();
    this.initializeProductDropdownSettings();
    this.BranchIds = [];
    this.SblProductIds = [];
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result: any) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }
  Get_User_Defined_Reports() {
    this.showSpinner = true;
    const requestData = {};
    this.reportsService
      .Get_User_Defined_Reports({ JSON: JSON.stringify(requestData) })
      .subscribe((response: any) => {
        if (response.length > 0) {
          this.reportData = response;
        }
        this.showSpinner = false;
      });
  }

  onReportSearch() {
    this.showSpinner = true;

    const params = [];

    if (this.selectedReport?.From_Date) {
      const formattedFromDate = moment(this.FromDate).format("YYYY-MM-DD");
      params.push(`@FromDate = '${formattedFromDate}'`);
    }

    if (this.selectedReport?.To_Date) {
      const formattedToDate = moment(this.ToDate).format("YYYY-MM-DD");
      params.push(`@To = '${formattedToDate}'`);
    }

    if (this.selectedReport?.Is_loginUserId) {
      params.push(`@LoginUserId = ${this.currentUser.userId}`);
    }

    if (
      this.selectedReport?.Report_Name === 'Disbursement Summary' ||
      this.selectedReport?.Report_Name === 'Los Booking list'
    ) {
      params.push(`@SourceType = '${this.SelectSourceType || ''}'`);
      params.push(`@SourceId = '${this.LeadSourceName.length > 0 ? this.LeadSourceName.map((x: any) => x.PartnerId).join(',') : '0'}'`);
      params.push(`@LoanAcCategory = '${this.LoanAccountCategory?.length > 0 ? this.getSelectedIds(this.LoanAccountCategory, 'Loan_CategoryId') : '0'}'`);
      params.push(`@BranchId = '${this.BranchIds.length > 0 ? this.BranchIds.map((x: any) => x.BranchId).join(',') : '0'}'`);
      params.push(`@ProductId = '${this.SblProductIds.length > 0 ? this.SblProductIds.map((x: any) => x.ProductId).join(',') : '0'}'`);
    }

    this.data = `EXEC ${this.selectedReport.Stored_Procedures_Name} ${params.join(", ")}`;
    console.log("Executing Query:", this.data);

    this.reportsService
      .Client_Dynamic_Report({ SpExecute: this.data })
      .subscribe((res: any) => {
        this.clientData = res;
        if (res && res.length > 0) {
          this.originalData = res; // ⭐ store original data

          this.displayedColumns = Object.keys(res[0]).filter(
            (col) => col !== "BranchId" && col !== "CaseNo" 
        );

          this.dataSource = new MatTableDataSource(res);
          // this.dataSource.paginator = this.paginator;
          // this.dataSource.sort = this.sort;
          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          });

          // // ⭐ Branch filter logic
          // this.dataSource.filterPredicate = (data: any, filter: string) => {
          //   const branchId = filter;

          //   // if no branch selected -> show all
          //   if (!branchId) return true;

          //   return String(data.BranchId) === String(branchId);
          // };
          this.dataSource.filterPredicate = (data: any, filter: string) => {
          const search = JSON.parse(filter);

          // Branch Filter
          const branchMatch =
            !search.branchId ||
            String(data.BranchId) === String(search.branchId);

          // Text Search
          const textMatch = Object.keys(data).some(key =>
            String(data[key] ?? '')
              .toLowerCase()
              .includes(search.text.toLowerCase())
          );

          return branchMatch && textMatch;
        };
          this.onBranchChange();
        } else {
          this.displayedColumns = [];
          this.dataSource = new MatTableDataSource([]);
        }

        this.showSpinner = false;
      });
  }
  getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }
  exportToExcel() {
    if (!this.dataSource.data || this.dataSource.data.length === 0) {
      this.snackBar.open("No data available to export", "Close", this.configSuccess);
      return;
    }

    const data = this.dataSource.data.map(row => {
      const obj: any = {};
      this.displayedColumns.forEach(col => {
        obj[col] = row[col] ?? "";
      });
      return obj;
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    FileSaver.saveAs(blob, "user-defined-report.xlsx");
  }
  // applyFilter(filterValue: string) {
  //   this.dataSource.filter = filterValue.trim().toLowerCase();
  // }
  // onBranchChange() {
  //   // MatTableDataSource filter expects a string
  //   this.dataSource.filter = this.BranchId ? String(this.BranchId) : "";

  //   // reset paginator to first page
  //   if (this.dataSource.paginator) {
  //     this.dataSource.paginator.firstPage();
  //   }
  // }
  applyFilter(filterValue: string) {
  this.searchFilter = filterValue.trim().toLowerCase();

  this.dataSource.filter = JSON.stringify({
    branchId: this.BranchId,
    text: this.searchFilter
  });
}
onBranchChange() {
  this.dataSource.filter = JSON.stringify({
    branchId: this.BranchId,
    text: this.searchFilter
  });
}

  Get_Loan_Accounting_Category_ForDropdown() {
    this.lmsService
      .Get_Loan_Accounting_Category_ForDropdown({ ProductId: 0 })
      .subscribe((res: any) => {
        this.catgegoryIdList = res;
      });
  }

  onCategorySelectionChange() {
    this.catgegoryIdList = this.moveSelectedItemsToTop(
      this.catgegoryIdList,
      this.LoanAccountCategory,
      "Loan_CategoryId"
    );
  }

  getSelectedIds(items: any[], key: string): string {
    return items?.map((item) => item[key]).join(",") || "0";
  }

  initializeCategoryDropdownSettings() {
    this.categoryDropdownSettings = {
      singleSelection: false,
      idField: "Loan_CategoryId",
      textField: "Loan_category",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };
  }

  getLeadSourceDropdown() {
    this.showSpinner = true;
    this.losService.getLeadSourceDropdown({}).subscribe((res: any) => {
      this.leadSourceDropdown = res;
      this.showSpinner = false;
    });
  }

  Get_PartnerForDropdown(sourceType: any) {
    this.SelectSourceType = sourceType ?? this.SelectSourceType;

    if (
      this.SelectSourceType == "Agent" ||
      this.SelectSourceType == "DSA" ||
      this.SelectSourceType == "Dealer"
    ) {
      this.losService
        .Get_PartnerForDropdown({
          PartnerType: this.SelectSourceType,
          branchId: 0,
        })
        .subscribe((res: any) => {
          this.partnerDropdown = res;
        });
      this.LeadSourceName = [];
    } else if (
      this.SelectSourceType == "Sales Executive" ||
      this.SelectSourceType == "Telecaller Executive" ||
      this.SelectSourceType == "Marketing Executive"
    ) {
      this.partnerDropdown = [];
      this.showSpinner = true;
      this.SalesExecutiveData.forEach((obj: any) => {
        this.partnerDropdown.push({
          PartnerId: obj.EmpId,
          Partner_Name: obj.EmpName,
        });
      });
      this.showSpinner = false;
    } else {
      this.LeadSourceName = [];
    }
  }

  GetSalesExecutive() {
    this.losService
      .getEmployeeDropdown({
        BranchId: 0,
        ProcessId: 1,
        ProductId: 0,
      })
      .subscribe((res: any) => {
        this.SalesExecutiveData = res;
        this.Get_PartnerForDropdown(this.SelectSourceType);
      });
  }

  onSourceNameSelectionChange() {
    this.partnerDropdown = this.moveSelectedItemsToTop(
      this.partnerDropdown,
      this.LeadSourceName,
      "PartnerId"
    );
  }

  getProductDropdown() {
    this.MasterService.GetProductForDropdown().subscribe((result: any) => {
      this.ProductList = result;
    });
  }

  initializeBranchDropdownSettings() {
    this.branchDropdownSettings = {
      singleSelection: false,
      idField: "BranchId",
      textField: "Branch_Name",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };
  }

  onSblBranchSelectionChange() {
    this.BranchesList = this.moveSelectedItemsToTop(
      this.BranchesList,
      this.BranchIds,
      "BranchId"
    );
  }

  initializeProductDropdownSettings() {
    this.productDropdownSettings = {
      singleSelection: false,
      idField: "ProductId",
      textField: "Product_Name",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };
  }

  onSblProductSelectionChange() {
    this.ProductList = this.moveSelectedItemsToTop(
      this.ProductList,
      this.SblProductIds,
      "ProductId"
    );
  }

  moveSelectedItemsToTop(items: any[], selectedItems: any[], key: string): any[] {
    if (!items?.length) return [];
    if (!selectedItems?.length) return items;

    const selectedIds = selectedItems.map((s) => s[key]);
    const selected = items.filter((i) => selectedIds.includes(i[key]));
    const rest = items.filter((i) => !selectedIds.includes(i[key]));
    return [...selected, ...rest];
  }
}
